import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_MAP_LAYER } from '../../constants/MAP_CONFIGS';

const initialState = {
  // Global per-user map layer, kept in sync with GET/PUT /userPreferences.
  defaultMapLayer: DEFAULT_MAP_LAYER
};

export const mapPreferencesSlice = createSlice({
  name: 'mapPreferences',
  initialState,
  reducers: {
    setDefaultMapLayer: (state, action) => {
      state.defaultMapLayer = action?.payload || DEFAULT_MAP_LAYER;
    }
  }
});

export const { setDefaultMapLayer } = mapPreferencesSlice?.actions;

export default mapPreferencesSlice?.reducer;
